module.exports = __webpack_public_path__ + "media/images/StanfordAlumniWhiteLogo-52775b880f198c61b18dfb0ceee3cb37.png";